const labelList = [
  {id: 301, name: 'High Priority', type: 1, color: 'red'},
  {id: 302, name: 'Important', type: 2, color: 'green'},
  {id: 303, name: 'Crema', type: 3, color: 'primary.main'},
  {id: 304, name: 'Work Place', type: 4, color: 'text.secondary'},
];
export default labelList;
